import { Form, Table } from "react-bootstrap";
import { useState } from "react";
import AddSubCategory from "./AddSubCategory";
import UpdateSubCategory from "./UpdateSubCategory";
import Moment from "react-moment";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { storeSubCategoryServices } from "../../../../../APIServices/SitePilotManagement/StoreManagement/storeSubCategoryServices";
import ToolBar from "../../../../Componant/ToolBar";
import UseToggle from "../../../../../Hooks/UseToggle";

const SubCategoryManagement = ({storeCategories}) => {
  const toggles = UseToggle();
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [storeSubCategories, setStoreSubCategories] = useState([]);
  const [storeSubCategoryData, setStoreSubCategoryData] = useState("");
  const [storeSubCategoryCount, setStoreSubCategoryCount] = useState(0);
  const [storeSubCategoryIds, setStoreSubCategoryIds] = useState([]);

  const toggleSingle = (id) => {
    setStoreSubCategoryIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const toggleAll = () => {
    if (storeSubCategoryIds.length === storeSubCategories.length) {
      setStoreSubCategoryIds([]);
    } else {
      setStoreSubCategoryIds(storeSubCategories.map((c) => c.id));
    }
  };

  const isAllChecked =
    storeSubCategories.length > 0 && storeSubCategoryIds.length === storeSubCategories.length;
  const isChecked = (id) => storeSubCategoryIds.includes(id);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPages = Math.ceil(storeSubCategoryCount / itemsPerPage);

  const start = (pageNumber - 1) * itemsPerPage + 1;
  const end = Math.min(pageNumber * itemsPerPage, storeSubCategoryCount);

  const getStoreSubCategoryList = async () => {
    setLoader(true);
    let data = await storeSubCategoryServices.getStoreSubCategoryList(
      "all",
      "all",
      search,
      pageNumber,
      itemsPerPage,
    );
    setStoreSubCategories(data?.data || []);
    setStoreSubCategoryCount(data?.count || 0);
    setLoader(false);
  };

  const updatedStoreSubCategory = async (subCategoryId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${status} this Store Sub Category?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.subCategoryId = subCategoryId;
        userData.status = status;
        let data = await storeSubCategoryServices.updatedStoreSubCategory(userData);
        if (data?.statusCode === 200) {
          getStoreSubCategoryList();
        }
      }
    });
  };

  const deleteStoreSubCategory = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this Store Sub Category?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.subCategoryIds = storeSubCategoryIds;
        let data = await storeSubCategoryServices.deleteStoreSubCategory(userData);
        if (data?.statusCode === 200) {
          getStoreSubCategoryList();
        }
      }
    });
  };

  useEffect(() => {
    let storeSubCategoryData = storeSubCategories?.find(
      (item) => item.subCategoryId === storeSubCategoryIds?.[0],
    );
    setStoreSubCategoryData(storeSubCategoryData || "");
  }, [storeSubCategoryIds]);

  useEffect(() => {
    getStoreSubCategoryList();
  }, [search, pageNumber, itemsPerPage]);

  return (
    <>
      <ToolBar
        toggles={toggles}
        search={search}
        setSearch={setSearch}
        checkedIds={storeSubCategoryIds}
        setCheckedIds={setStoreSubCategoryIds}
        start={start}
        end={end}
        totalItems={storeSubCategoryCount}
        page={pageNumber}
        setPage={setPageNumber}
        setPageSize={setItemsPerPage}
        pageSize={itemsPerPage}
        totalPages={totalPages}
        deleteData={deleteStoreSubCategory}
        addField
        editField
      />
      <div className={`contacts-layout`}>
        <div
          className={`table-section overflow-auto bg-white `}
          style={{ height: "calc(100vh - 182px)" }}
        >
          <Table
            hover
            className="contacts-table mb-0"
            style={{ verticalAlign: "middle" }}
          >
            <thead>
              <tr>
                <th>
                  <div className="d-flex align-items-center gap-2">
                    <div className="px-2">
                      <Form.Check
                        type="checkbox"
                        checked={isAllChecked}
                        onChange={toggleAll}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                    <div>Sub Category</div>
                  </div>
                </th>
                <th>Category</th>
                <th>Total Post</th>
                <th>Status</th>
                <th>Created Date | Time</th>
                <th>Updated Date | Time</th>
              </tr>
            </thead>
            <tbody>
              {storeSubCategories?.map((item) => (
                <tr key={item.subCategoryId}>
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <div className="px-2">
                        <Form.Check
                          type="checkbox"
                          checked={isChecked(item.subCategoryId)}
                          onChange={() => toggleSingle(item.subCategoryId)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div>
                        <div className="fw-medium">{item.name}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span className="fw-medium">{item.categoryName}</span>
                  </td>
                  <td>
                    <span className="fw-medium">{item.totalPost || 0}</span>
                  </td>
                  <td>
                    <Form.Check
                      type="switch"
                      onChange={() =>
                        updatedStoreSubCategory(
                          item?.subCategoryId,
                          item.status === "active" ? "inactive" : "active",
                        )
                      }
                      checked={item.status === "active"}
                    />
                  </td>
                  <td>
                    <span className="fw-medium">
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item?.createdAt}
                      </Moment>
                    </span>
                  </td>
                  <td>
                    <span className="fw-medium">
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item?.updatedAt}
                      </Moment>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
      <AddSubCategory
        show={!toggles.toggle}
        hide={() => toggles.setToggle()}
        title={`Add Sub Category`}
        getStoreSubCategoryList={getStoreSubCategoryList}
        storeCategories={storeCategories}
      />
      <UpdateSubCategory
        show={!toggles.toggle1}
        hide={() => toggles.setToggle1()}
        title={`Update Sub Category`}
        storeSubCategoryData={storeSubCategoryData}
        setStoreSubCategoryData={setStoreSubCategoryData}
        setStoreSubCategoryIds={setStoreSubCategoryIds}
        getStoreSubCategoryList={getStoreSubCategoryList}
      />
    </>
  );
};

export default SubCategoryManagement;
